import { useCallback, useEffect } from 'react';
import useRequestContext from '../context/requestContext';
import { getProfessionProofs } from '../Services/httpCalls';

export default function useProfessionProofs() {
  const { professionProofs, setProfessionProofs } = useRequestContext();

  const getProofs = useCallback(async () => {
    const res = await getProfessionProofs();

    if (res) {
      const mappedProofs = res.proofs.map((item) => ({
        id: item.id,
        label: item.description,
        fileRequired: item?.file_required ?? 0,
      }));
      setProfessionProofs(mappedProofs);
    }
  }, [setProfessionProofs]);

  useEffect(() => {
    if (professionProofs.length > 0) return;

    getProofs();
  }, []);

  return { professionProofs };
}
